import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import scrollTo from '../../utils/scrollTo';

const LinkWrapper = ({ children, resetScrollToTop, to: id, ...props }) => {
    const { formatMessage, locale } = useIntl();
    const handleClick = () => {
        if (resetScrollToTop) {
            scrollTo(0, 0);
        }
    };
    return (
        <Link
            onClick={handleClick}
            to={(currentLocation) => ({
                pathname: `/${locale}` + formatMessage({ id }),
                state: { from: { pathname: currentLocation.pathname } },
            })}
            {...props}
        >
            {children}
        </Link>
    );
};

LinkWrapper.defaultProps = {
    resetScrollToTop: true,
};

export default LinkWrapper;
